import { render } from "./ListeAssurance.vue?vue&type=template&id=b94981b2&scoped=true"
import script from "./ListeAssurance.vue?vue&type=script&lang=js"
export * from "./ListeAssurance.vue?vue&type=script&lang=js"

import "./ListeAssurance.vue?vue&type=style&index=0&id=b94981b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b94981b2"]])

export default __exports__